import { useConfirmacaoDialog } from "./use-confirmacao-dialog";
import { ConfirmacaoDialogView } from "./view-confirmacao-dialog";
import type { ConfirmacaoDialogProps } from "./types-confirmacao-dialog";

export function ConfirmacaoDialog(props: ConfirmacaoDialogProps) {
  const vm = useConfirmacaoDialog(props);

  return <ConfirmacaoDialogView {...props} {...vm} />;
}

export type * from "./types-confirmacao-dialog";
